import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {StatisticsComponent} from './components/statistics/statistics.component';
import {PrlStatisticsRoutingModule} from './prl-statistics-routing.module';
import {MatCardModule} from '@angular/material/card';
import {MatLabel} from '@angular/material/input';
import {MatOption, MatSelectModule} from '@angular/material/select';
import {
    MxButtonModule,
    MxFormModule,
    MxGridModule,
    MxInfoTooltipModule,
    MxPreloaderModule,
    MxSharedModule
} from 'mx-core';
import {PrlLanguageModule} from '../prl-language/prl-language.module';

@NgModule({
    declarations: [StatisticsComponent],
    imports: [
        CommonModule,
        PrlStatisticsRoutingModule,
        MatCardModule,
        MatLabel,
        MatOption,
        MatSelectModule,
        MxSharedModule,
        MxFormModule,
        MxButtonModule,
        MxInfoTooltipModule,
        MxGridModule,
        PrlLanguageModule,
        MxPreloaderModule
    ]
})
export class PrlStatisticsModule { }
